export default __webpack_public_path__ + "static/media/laser_virtual.5fa0db54.jpg";